import { Control } from 'react-hook-form';

import FormController from 'portal/src/components/common/forms/FormController';

import { FormValues } from '../AllocationTemplateForm';

const PercentField = ({
  control,
  name,
}: {
  control: Control<FormValues, any, FormValues>;
  name: string;
}) => (
  <FormController
    control={control}
    fieldConf={{
      adornmentText: '%',
      inputType: 'number',
      name,
      placeholder: '',
      required: true,
      size: 'small',
      type: 'textInput',
    }}
  />
);

export default PercentField;
